export default "__VITE_ASSET__7dS6bXc9__"